import { render, staticRenderFns } from "./listofTopics.vue?vue&type=template&id=0b365918&scoped=true&"
import script from "./listofTopics.vue?vue&type=script&lang=js&"
export * from "./listofTopics.vue?vue&type=script&lang=js&"
import style0 from "./listofTopics.vue?vue&type=style&index=0&id=0b365918&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b365918",
  null
  
)

export default component.exports